import { render, staticRenderFns } from "./CityPlatUpload.vue?vue&type=template&id=04409c02&scoped=true"
import script from "./CityPlatUpload.vue?vue&type=script&lang=js"
export * from "./CityPlatUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04409c02",
  null
  
)

export default component.exports